import React from "react";

// Fills that keep the white initials at 6.4:1 contrast or better.
const AVATAR_COLORS = ["#2f4fd8", "#7026ed", "#0c6762", "#b02254", "#106c33", "#964709"];

const hashString = (value) => {
  let h = 0;
  for (const ch of String(value || "")) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return h;
};

// "Yeo Guan Tan" -> "YG", "张伟" -> "张伟"[0] = "张", "" -> "?"
export const initialsOf = (name) => {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  const first = Array.from(parts[0])[0] || "";
  const second = parts.length > 1 ? Array.from(parts[1])[0] || "" : "";
  return (first + second).toUpperCase();
};

// Round initials badge; the same name always gets the same color.
// Styles are inline so it looks right on any page, in light and dark mode
// (the faint ring is a translucent grey that works on both backgrounds).
const Avatar = ({ name, size = 36 }) => (
  <span
    aria-hidden="true"
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      width: size,
      height: size,
      borderRadius: "50%",
      color: "#fff",
      fontWeight: 800,
      letterSpacing: "0.3px",
      fontSize: Math.max(12, Math.round(size * 0.38)), // never below 12px
      background: AVATAR_COLORS[hashString(name) % AVATAR_COLORS.length],
      boxShadow: "0 0 0 2px rgba(148, 163, 184, 0.35)",
    }}
  >
    {initialsOf(name)}
  </span>
);

export default Avatar;
